// ----------------------------------------------------------------------
// <copyright file="Izenda.PageService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { concat } = require('lodash/fp');
  var LoadingManager = require('modules/Izenda.LoadingManager');

  function PageService() {
    this.loadingCounter = 0;
    this.notifyLoadingChanged = null;
  }

  PageService.prototype.startLoading = function() {
    var old = this.loadingCounter++;
    if (old === 0) {
      LoadingManager.addLoadingWatcher(this);
      this.notifyLoadingChanged && this.notifyLoadingChanged.apply(null, concat([true], arguments));
    }
  };

  PageService.prototype.endLoading = function() {
    var old = this.loadingCounter;
    this.loadingCounter && --this.loadingCounter;
    if (old === 1) {
      LoadingManager.removeLoadingWatcher(this);
      this.notifyLoadingChanged && this.notifyLoadingChanged.apply(null, concat([false], arguments));
    }
  };

  PageService.prototype.registerLoadingChanged = function(func) {
    this.notifyLoadingChanged = func;
    return function() {
      delete this.notifyLoadingChanged;
    }.bind(this);
  };

  module.exports = PageService;
})();



// WEBPACK FOOTER //
// ./ui/share/page/Izenda.PageService.js